import { FC, Fragment, useState } from 'react'
import { Popover } from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { mobileScreenWidth } from 'utils'
import ApproveButton from '../../Button/ApproveButton'
import { MitigateRisk, MitigationPopoverProps } from './MitigateRisk'

const usePopoverStyles = makeStyles(
    createStyles({
        paper: {
            [`@media (max-width:${mobileScreenWidth})`]: {
                width: '100%',
            },
        },
    }),
)

export const ApproveRisk: FC<MitigationPopoverProps> = (props) => {
    const {
        decisionFriendlyName,
        globalRiskId,
        onSubmit,
        isLoading,
        ...rest
    } = props

    const popoverClasses = usePopoverStyles()

    const [anchorEl, setAnchorEl] = useState(null)

    const open = Boolean(anchorEl)

    const showConfirmation = (event: any) => {
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        setAnchorEl(null)
    }

    return (
        <Fragment>
            <ApproveButton size={'small'} onClick={showConfirmation}>
                {decisionFriendlyName}
            </ApproveButton>
            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                disableScrollLock={true}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                classes={popoverClasses}
            >
                {open && (
                    <MitigateRisk
                        globalRiskId={globalRiskId}
                        decisionFriendlyName={decisionFriendlyName}
                        onSubmit={(value) =>
                            onSubmit(value).then(() => handleClose())
                        }
                        handleClose={handleClose}
                        isLoading={isLoading}
                        {...rest}
                    />
                )}
            </Popover>
        </Fragment>
    )
}
